import React from 'react';

export default function NotFound() {
    return (
        <div className="container-lg">
            <div style={{marginTop: '3rem', fontSize: '400%', fontWeight: 600}}>
                ERRO 404
            </div>
            <div style={{marginTop: '2rem', fontSize: '150%'}}>
                Desculpe, a Página solicitada não foi encontrada!
            </div>
        </div>
    )
}